<template>
  <div class="booking-success">
    <img
      src="@/assets/images/booking/submit.png"
      alt=""
    >
    <p>
      提交成功
    </p>
    <div
      class="booking-success-back"
      @click="goBack"
    >
      返回首页
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      const query = this.$route.query;
      if (query.source === "qr") {
        this.$router.go(-1);
      } else {
        this.$router.replace({
          name: "BookingHome",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 35px;
  img {
    width: 92px;
    height: 92px;
    margin-top: 50%;
  }
  p {
    font-size: 18px;
    margin-top: 20px;
  }
  .booking-success-back {
    width: 100%;
    border-radius: 50px;
    background: #003057;
    text-align: center;
    padding: 15px 0;
    color: #eaeaea;
    font-size: 18px;
    margin-top: 100px;
    cursor: pointer;
  }
}
</style>